<template>
    <div class="col-12">
        <div class="card">
            <div class="card-body my-0 mx-0">
                <div class="row">
                    <div class="col-12">
                        <h4>{{ title }}</h4>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="form-group"
                            :class="{'has-danger': errors.title}"
                        >
                            <label class="control-label">
                                Nombre
                            </label>
                            <el-input v-model="form.title"
                                placeholder=""></el-input>
                            <small
                                v-if="errors.title"
                                class="form-control-feedback"
                                v-text="errors.title[0]">
                            </small>
                        </div>
                    </div>
                    <div class="col-12 col-md-9">
                        <div class="form-group"
                            :class="{'has-danger': errors.message}"
                        >
                            <label class="control-label">
                                Descripción
                            </label>
                            <el-input v-model="form.message"
                                placeholder=""></el-input>
                            <small
                                v-if="errors.message"
                                class="form-control-feedback"
                                v-text="errors.message[0]">
                            </small>
                        </div>
                    </div>
                    <div class="col-12 text-right mt-2">
                        <el-button v-show="form.id"
                            size="small"
                            @click.prevent="$emit('cancel')"
                        >
                            Cancelar
                        </el-button>
                        <el-button type="primary"
                            size="small"
                            @click.prevent="$emit('submit')"
                            :loading="loading"
                        >
                            {{ btnLabel }}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CreateEditNotification',

        props:{
            title: {
                type: String,
                required: true
            },
            form: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                default: () => ({})
            },
            btnLabel: {
                type: String,
                default: 'Crear Notificación'
            },
            loading: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                
            }
        },
        computed: {
            
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/partials/CreateEditNotification.vue